export const ROUTES = {
  INTEGRATIONS_COMMPIX: {
    route: '/integrations-commpix',
    name: 'IntegrationsCommpix',
  },
  INTEGRATIONS_MASSPAYMENTS: {
    route: '/integrations-masspayments',
    name: 'IntegrationsMasspayments',
  },
  INTEGRATIONS_MANTECA: {
    route: '/integrations-manteca',
    name: 'IntegrationsManteca',
  },
  INTEGRATIONS_PVS: {
    route: '/integrations-pvs',
    name: 'IntegrationsPvs',
  },
  SUPPORT_FORM: {
    route: '/support',
    name: 'SupportForm',
  },
  LOGIN: {
    route: '/login',
    name: 'Login',
  },
  HOME: {
    route: '/',
    name: 'home',
  },
  SALES_REPORT: {
    route: '/sales-report',
    name: 'salesReport',
  },
  TRANSACTION_HISTORY: {
    route: '/transaction-history',
    name: 'TransactionHistory',
  },
  DAILY_TRANSACTIONS_STATEMENT: {
    route: '/daily-transactions-statement',
    name: 'dailyTransactionsStatement',
  },
  SCAN_TO_PAY: {
    route: '/scan-to-pay',
    name: 'ScanToPay',
  },
  DINAMIC_PAYMENTS: {
    route: '/dinamic-payments',
    name: 'DinamicPayments',
  },
  BOLEPIX_COMMPIX: {
    route: '/bolepix',
    name: 'BolepixCommpix',
  },
  QR_PAYINS_COMMPIX: {
    route: '/qr-payins',
    name: 'QrPayinsCommpix',
  },
  TRANSFERENCES: {
    route: '/transferences',
    name: 'Transferences',
  },
  WITHDRAWALS: {
    route: '/withdrawals',
    name: 'Withdrawals',
  },
  BALANCE: {
    route: '/balance',
    name: 'balance',
  },
  PAYOUTS_CONFIGURATION: {
    route: '/payouts-configuration',
    name: 'PayoutsConfiguration',
  },
  PENDING_PAYOUTS: {
    route: '/pending-payouts',
    name: 'PendingPayouts',
  },
  PROFILE_CONFIGURATION: {
    route: '/configuration',
    name: 'ProfileConfiguration',
  },
  PROFILE: {
    route: '/profile',
    name: 'Profile',
  },
  REMOTE_PAYMENT_HOME: {
    route: 'remote-payment',
    name: 'RemotePaymentHome',
  },
  STAFF_HOME: {
    route: 'staff',
    name: 'StaffHome',
  },
  FORGOT_PASSWORD: {
    route: '/forgot-password',
    name: 'forgot-password',
  },
  RESET_PASSWORD: {
    route: '/reset-password/:id',
    name: 'reset-password',
  },
  SEND_UNLOCK_ACCOUNT_MAIL: {
    route: '/unlock-account',
    name: 'SendUnlockAccountMail',
  },
  UNLOCK_ACCOUNT: {
    route: '/unlock-account/:id',
    name: 'UnlockAccount',
  },
  SETUP_PASSWORD: {
    route: '/setup-password',
    name: 'setup-password',
  },
  SETUP_PASSWORD_CODE: {
    route: '/setup-password/:code',
    name: 'setup-password',
  },
  LANDING: {
    route: '/landing-page',
    name: 'Landing',
  },
};
